import React from 'react'
import { Translate } from 'react-redux-i18n'

import { AppType, AppMode, AppTheme } from '../types'
import MenuToggle from './MenuToggle'
import ThemeToggle from './ThemeToggle'

export interface Props {
  appType: AppType
  tradesCount: number
  ordersCount: number
  appMode: AppMode
  appTheme: AppTheme
  onSetAppMode: (mode: AppMode) => void
  onSetAppTheme: (theme: AppTheme) => void
}

export interface State {
  prevType: number
}
const AppModesSwitcher = (props: Props) => {
  return <AppModesSwitcherContent {...props} />
}

class AppModesSwitcherContent extends React.Component<Props, State> {
  public render() {
    const {
      tradesCount,
      ordersCount,
      appType,
      appMode,
      appTheme,
      onSetAppMode,
      onSetAppTheme,
    } = this.props
    return (
      <div className="d-flex flex-column actions AppModesSwitcher">
        <div className="d-flex flex-column actions">
          {appType === 'forex' && (
            <MenuToggle
              icon={<i className="icon-trade" />}
              label={<Translate value="trade" />}
              onToggle={onSetAppMode.bind(null, 'trade')}
              active={['trade', 'assetPosition'].includes(appMode)}
            />
          )}
          <MenuToggle
            icon={<i className="icon-open-positions" />}
            label={<Translate value="togglePositions" />}
            badgeText={tradesCount > 0 ? tradesCount.toString() : ''}
            onToggle={onSetAppMode.bind(null, 'positions')}
            active={appMode === 'positions'}
          />
          <MenuToggle
            icon={<i className="icon-pending-orders" />}
            label={<Translate value="togglePendingOrders" />}
            badgeText={ordersCount > 0 ? ordersCount.toString() : ''}
            onToggle={onSetAppMode.bind(null, 'orders')}
            active={appMode === 'orders'}
          />
          <MenuToggle
            icon={<i className="icon-trade-history" />}
            label={<Translate value="toggleTradeHistory" />}
            onToggle={onSetAppMode.bind(null, 'history')}
            active={appMode === 'history'}
          />
        </div>
        <div className="d-flex flex-column actions">
          <ThemeToggle theme={appTheme} onToggle={onSetAppTheme} />
        </div>
      </div>
    )
  }
}

export default AppModesSwitcher
